/* Specification extras. Must not observe the spec panel (that froze PDPs). */
(function () {
  "use strict";
  if (window.__artfolioSpecEnhance) return;
  window.__artfolioSpecEnhance = true;

  function parseCm(text) {
    var re = /([\d.]+)\s*[×x]\s*([\d.]+)/g;
    var last = null;
    var m;
    while ((m = re.exec(String(text || "")))) {
      last = { w: parseFloat(m[1], 10), h: parseFloat(m[2], 10) };
    }
    return last;
  }

  function orientName(w, h) {
    if (!w || !h) return "";
    var max = Math.max(w, h);
    if (!max) return "";
    if (Math.abs(w - h) / max <= 0.08) return "Square";
    return w > h ? "Landscape" : "Portrait";
  }

  function sync(panel) {
    var printDd = panel.querySelector('[data-spec="print-size"] [data-spec-value]');
    var orientRow = panel.querySelector('[data-spec="orientation"]');
    var orientDd = orientRow && orientRow.querySelector("[data-spec-value]");
    var dims = printDd ? parseCm(printDd.textContent) : null;
    if (orientRow && orientDd && dims) {
      var nextOrient = orientName(dims.w, dims.h);
      if (nextOrient && orientDd.textContent !== nextOrient) orientDd.textContent = nextOrient;
      if (orientRow.hasAttribute("hidden")) orientRow.removeAttribute("hidden");
    }

    var framedRow = panel.querySelector('[data-spec="framed-size"]');
    var framedDd = framedRow && framedRow.querySelector("[data-spec-value]");
    if (framedDd && framedRow && !framedRow.hasAttribute("hidden")) {
      var raw = String(framedDd.textContent || "");
      var cleaned = raw
        .replace(/\s+across both panels\s*$/i, "")
        .replace(/\s+across all panels\s*$/i, "")
        .replace(/\s+$/, "");
      var sizeName = document.querySelector("[data-bb-size-name]");
      var layout = ((sizeName && sizeName.textContent) || "").toLowerCase();
      var next = cleaned;
      if (layout.indexOf("diptych") >= 0) next += " across both panels";
      else if (layout.indexOf("triptych") >= 0) next += " across all panels";
      if (framedDd.textContent !== next) framedDd.textContent = next;
    }
  }

  function syncAll() {
    var panels = document.querySelectorAll("[data-spec-panel]");
    Array.prototype.forEach.call(panels, sync);
  }

  function scheduleSync() {
    window.requestAnimationFrame(function () {
      window.setTimeout(syncAll, 0);
    });
  }

  function boot() {
    document.addEventListener("click", function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest("[data-value], [data-pp-type], [data-bb-row], [data-bb-panel], [data-option-index]")) return;
      scheduleSync();
    });
    document.addEventListener("artfolio:spec-updated", scheduleSync);
    scheduleSync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
